/**
 * @group Components
 * @summary WhatsAppIcon icon component.
 * @example
 * ```tsx
 * <WhatsAppIcon />
 * ```
 */
export const WhatsAppIcon = ({ size = 16 }: { size?: number }) => {
  return (
    <svg
      height={size}
      width={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ color: 'currentcolor' }}
    >
      <path
        d="M20.52 3.48C18.38 1.34 15.53 0.2 12.5 0.2C6.07 0.2 0.85 5.42 0.85 11.85C0.85 13.96 1.44 15.98 2.54 17.71L1 23L6.42 21.49C8.08 22.43 10.04 22.95 12.1 22.95C18.53 22.95 23.75 17.73 23.75 11.3C23.75 8.27 22.66 5.42 20.52 3.28V3.48Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
      <path
        d="M8.9 6.9C8.9 6.9 8.05 7.93 7.9 8.4C7.69 9.06 8.23 10.09 9.17 11.03C10.11 11.97 11.14 12.51 11.8 12.3C12.27 12.15 13.3 11.3 13.3 11.3C13.3 11.3 14.18 11.41 14.83 12.07C15.49 12.72 15.6 13.6 15.6 13.6C15.6 13.6 14.45 15.02 13.19 15.53C11.92 16.04 9.99 15.86 8.35 14.22C6.71 12.58 6.54 10.65 7.05 9.38C7.56 8.11 8.9 6.9 8.9 6.9Z"
        fill="currentColor"
      />
    </svg>
  );
};


